document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('.wpcf7 form'); 
    forms.forEach(function (form) {
        const hiddenField = form.querySelector('input[name="page_url"]');
        if (hiddenField) {
            hiddenField.value = window.location.href; 
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll(".section-forms");

    sections.forEach((section) => {
        const checkbox = section.querySelector("#checkbox");
        const btn = section.querySelector("button");

        if (checkbox && btn) {
            btn.disabled = !checkbox.checked;

            checkbox.addEventListener("change", () => {
                btn.disabled = !checkbox.checked;
            });
        }
    });
});
